"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _DropdownImage = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownImage"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _ArrowDropdown = _interopRequireDefault(require("@insided/shared/icons/ArrowDropdown"));

var DropdownText = function DropdownText(_ref) {
  var badges = _ref.badges,
      selected = _ref.selected;

  if (badges.length === 0) {
    return (0, _preact.h)(Fragment, null, "There are no badges available");
  }

  if (selected) {
    return (0, _preact.h)("span", {
      className: "selected"
    }, (0, _preact.h)("div", null, selected.image && (0, _preact.h)(_DropdownImage.default, {
      image: selected.image
    })), (0, _preact.h)("div", {
      className: "truncated"
    }, selected.title));
  }

  return (0, _preact.h)(Fragment, null, "Choose a badge");
};

function normalizeBadges(badgeList, onChange) {
  return badgeList.map(function (badge) {
    var onClick = function onClick(event) {
      var target = event.target;
      onChange(target.getAttribute('data-value'));
    };

    return {
      value: badge.id,
      title: badge.title,
      image: badge.image,
      onClick: onClick,
      variant: 'primary'
    };
  });
}

var BadgeSelector = function BadgeSelector(_ref2) {
  var badges = _ref2.badges,
      selected = _ref2.selected,
      onChange = _ref2.onChange,
      error = _ref2.error;
  var normalizedBadges = badges && normalizeBadges(badges, onChange);
  return (0, _preact.h)("div", {
    className: "badge-selector-wrapper"
  }, (0, _preact.h)(_DropdownControl.default, {
    align: "adjust",
    trigger: (0, _preact.h)(_Button.default, {
      title: (0, _preact.h)(DropdownText, {
        badges: badges,
        selected: selected
      }),
      className: (0, _classnames.default)('badge-selector', 'qa-badge-selector', {
        error: error,
        'no-badge-selected-message': !selected
      }),
      icon: (0, _preact.h)(_ArrowDropdown.default, {
        width: 24,
        height: 24
      })
    }),
    items: normalizedBadges,
    hasSearch: true,
    closeOnDropdownClick: true
  }), error && (0, _preact.h)("span", {
    className: "error"
  }, error));
};

var _default = BadgeSelector;
exports.default = _default;